import * as Sentry from '@sentry/react';
import { PropsWithChildren, useEffect } from 'react';
import { useAponoAuth } from '@common/ui/Authenticated';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.VITE_ENVIRONMENT,
});

function SentryWrapper({ children }: PropsWithChildren) {
  const { user } = useAponoAuth();

  useEffect(() => {
    const { id, email, name: username } = user;

    Sentry.setUser({
      email,
      username,
      id,
    });
  }, [user]);

  return <>{children}</>;
}

export default SentryWrapper;
